var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer-service 1",
    clipPath: "url(#clip0_607_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3732 26.0741C21.6315 15.6441 28.149 7.77563 34.6954 5.16863V5.18513C34.7758 4.1745 34.9078 3.26494 35.046 2.49975C35.3121 1.04569 36.5888 0 38.0696 0H57.4716C69.5434 0 77.4655 14.0786 72.9816 26.4041L69.9167 34.8336H30.3559L26.3753 26.0762L26.3732 26.0741Z",
    fill: "url(#paint0_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M78.3752 99H20.6252C17.5562 99 14.6667 97.6429 12.7011 95.2752C10.7314 92.9053 9.92704 89.8095 10.4922 86.7818L13.423 71.1666C14.4357 65.7051 18.4184 61.3883 23.8118 59.9053L38.1111 56.0093C45.5588 53.9777 53.4396 53.9777 60.8914 56.0093L75.1866 59.9053H75.1907C80.5842 61.3883 84.5669 65.7051 85.5816 71.1707L88.5083 86.7797C89.0734 89.8075 88.2711 92.9033 86.3014 95.2752C84.3359 97.6429 81.4442 99 78.3752 99Z",
    fill: "url(#paint1_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.5,
    d: "M47.4375 66H51.5625V99H47.4375V66Z",
    fill: "url(#paint2_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.0625 82.5H28.875C27.7344 82.5 26.8125 81.576 26.8125 80.4375C26.8125 79.299 27.7344 78.375 28.875 78.375H35.0625C36.2031 78.375 37.125 79.299 37.125 80.4375C37.125 81.576 36.2031 82.5 35.0625 82.5Z",
    fill: "url(#paint3_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45.375 53.625H53.625C61.5986 53.625 68.0625 60.0889 68.0625 68.0625C68.0625 70.3416 66.2166 72.1875 63.9375 72.1875H35.0625C32.7834 72.1875 30.9375 70.3416 30.9375 68.0625C30.9375 60.0889 37.4014 53.625 45.375 53.625Z",
    fill: "url(#paint4_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.1875 49.5825V61.875C39.1875 67.5696 43.8054 72.1875 49.5 72.1875C55.1946 72.1875 59.8125 67.5696 59.8125 61.875V49.5825H39.1875Z",
    fill: "url(#paint5_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M68.0646 49.5H57.75C56.6094 49.5 55.6875 48.576 55.6875 47.4375C55.6875 46.299 56.6094 45.375 57.75 45.375H68.0646C69.2031 45.375 70.1271 44.4489 70.1271 43.3125V37.125C70.1271 35.9865 71.049 35.0625 72.1896 35.0625C73.3301 35.0625 74.2521 35.9865 74.2521 37.125V43.3125C74.2521 46.7239 71.4759 49.5 68.0646 49.5Z",
    fill: "url(#paint6_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M70.125 41.25H66C64.8594 41.25 63.9375 40.326 63.9375 39.1875V26.8125C63.9375 25.674 64.8594 24.75 66 24.75H70.125C73.5364 24.75 76.3125 27.5261 76.3125 30.9375V35.0625C76.3125 38.4739 73.5364 41.25 70.125 41.25Z",
    fill: "url(#paint7_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.6875 35.0625V30.9375C22.6875 27.5261 25.4636 24.75 28.875 24.75H33C34.1406 24.75 35.0625 25.674 35.0625 26.8125V39.1875C35.0625 40.326 34.1406 41.25 33 41.25H28.875C25.4636 41.25 22.6875 38.4739 22.6875 35.0625Z",
    fill: "url(#paint8_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M30.9375 41.25V26.8125C30.9375 22.2564 34.6314 18.5625 39.1875 18.5625H59.8125C64.3686 18.5625 68.0625 22.2564 68.0625 26.8125V41.25C68.0625 45.2121 66.4888 49.0112 63.6879 51.8121L60.0641 55.4359C57.2632 58.2368 53.4641 59.8104 49.5021 59.8104C45.54 59.8104 41.7409 58.2368 38.94 55.4359L35.3162 51.8121C32.5153 49.0112 30.9416 45.2121 30.9416 41.25H30.9375Z",
    fill: "url(#paint9_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M68.0646 49.5H57.75C56.6094 49.5 55.6875 48.576 55.6875 47.4375C55.6875 46.299 56.6094 45.375 57.75 45.375H68.0646V49.5Z",
    fill: "url(#paint10_linear_607_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M55.6875 43.3125H51.5625C49.2843 43.3125 47.4375 45.1593 47.4375 47.4375C47.4375 49.7157 49.2843 51.5625 51.5625 51.5625H55.6875C57.9657 51.5625 59.8125 49.7157 59.8125 47.4375C59.8125 45.1593 57.9657 43.3125 55.6875 43.3125Z",
    fill: "url(#paint11_linear_607_1909)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_1909",
    x1: 24.1189,
    y1: 6.19163,
    x2: 67.8645,
    y2: 28.8936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_607_1909",
    x1: 49.5002,
    y1: 56.8178,
    x2: 49.5002,
    y2: 99.5672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_607_1909",
    x1: 49.5,
    y1: 71.3996,
    x2: 49.5,
    y2: 98.3998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B50D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182EA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_607_1909",
    x1: 26.9012,
    y1: 78.3606,
    x2: 36.7146,
    y2: 82.3824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_607_1909",
    x1: 49.5,
    y1: 56.0299,
    x2: 49.5,
    y2: 71.4863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FC6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50A7F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_607_1909",
    x1: 40.5384,
    y1: 54.5841,
    x2: 59.4557,
    y2: 63.8055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1D2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_607_1909",
    x1: 64.9687,
    y1: 39.7134,
    x2: 64.9687,
    y2: 49.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA5A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_607_1909",
    x1: 70.125,
    y1: 25.2883,
    x2: 70.125,
    y2: 41.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_607_1909",
    x1: 28.875,
    y1: 25.2883,
    x2: 28.875,
    y2: 41.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_607_1909",
    x1: 49.5,
    y1: 19.8495,
    x2: 49.5,
    y2: 60.0146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1D2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#F2CFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#F5C7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#FBBB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_607_1909",
    x1: 61.875,
    y1: 0.00000146108,
    x2: 61.875,
    y2: 49.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA5A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_607_1909",
    x1: 53.625,
    y1: 43.1021,
    x2: 53.625,
    y2: 50.6736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2367EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_1909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/SupportIcon.2b29fe23be57c69b0af7b2b20ed03d56.svg";
export { ForwardRef as ReactComponent };